import {Space, Steps} from "antd";
import {useCreateSubscriptionContext} from "../../context/create-subscription";
import {CreateSubscriptionSteps} from "../../reducers/create-subscription/types";

export function CreateSubscriptionFormSteps() {
  const {state} = useCreateSubscriptionContext();
  const mapStepToNumber: Record<CreateSubscriptionSteps, number> = {
    basicForm: 0,
    coverImagesUpload: 1,
    automations: 2,
    checkoutForm: 3,
  };

  return (
    <div>
      <Steps
        current={mapStepToNumber[state.currentCreateSubscriptionStep]}
        size="small"
        direction="vertical"
      >
        <Steps.Step title="Subscription information" />
        <Steps.Step
          title="Cover image upload"
          disabled={state.currentCreateSubscriptionStep === "basicForm"}
        />
        <Steps.Step
          title="Automations"
          disabled={
            state.currentCreateSubscriptionStep === "basicForm" ||
            state.currentCreateSubscriptionStep === "coverImagesUpload"
          }
        />
        <Steps.Step
          title="Checkout form"
          disabled={
            state.currentCreateSubscriptionStep === "basicForm" ||
            state.currentCreateSubscriptionStep === "coverImagesUpload" ||
            state.currentCreateSubscriptionStep === "automations"
          }
        />
      </Steps>
    </div>
  );
}

export function CreateSubscriptionFormStepsMobile() {
  const {state} = useCreateSubscriptionContext();
  const mapStepToNumber: Record<CreateSubscriptionSteps, number> = {
    basicForm: 0,
    coverImagesUpload: 1,
    automations: 2,
    checkoutForm: 3,
  };
  const mapStepToTitle: Record<CreateSubscriptionSteps, string> = {
    basicForm: "Subscription information",
    coverImagesUpload: "Cover image upload",
    automations: "Automations",
    checkoutForm: "Checkout form",
  };
  return (
    <Space size={16} align="center">
      <div
        style={{
          width: "2.4rem",
          height: "2.4rem",
          borderRadius: "3.2rem",
          backgroundColor: "#222222",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {mapStepToNumber[state.currentCreateSubscriptionStep] + 1}
      </div>

      <p>{mapStepToTitle[state.currentCreateSubscriptionStep]}</p>
    </Space>
  );
}
